var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0A7.496 7.496 0 0 0 0 7.5C0 11.645 3.354 15 7.5 15c4.145 0 7.5-3.354 7.5-7.5C15 3.355 11.646 0 7.5 0zm0 13.953A6.46 6.46 0 0 1 1.047 7.5 6.46 6.46 0 0 1 7.5 1.047 6.46 6.46 0 0 1 13.953 7.5 6.46 6.46 0 0 1 7.5 13.953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.278 9.49a.758.758 0 0 0-.75.76c0 .405.326.76.75.76.425 0 .76-.355.76-.76a.767.767 0 0 0-.76-.76zM7.406 3.734c-1.332 0-1.944.79-1.944 1.323 0 .385.325.563.592.563.533 0 .316-.76 1.323-.76.493 0 .888.217.888.671 0 .533-.553.84-.878 1.116-.287.247-.662.651-.662 1.5 0 .514.138.662.543.662.484 0 .583-.217.583-.405 0-.513.01-.81.552-1.234.267-.207 1.106-.879 1.106-1.807 0-.928-.839-1.629-2.103-1.629z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.df857f80698dee024836ce9d53435a7f.svg";
export { ForwardRef as ReactComponent };